import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import ProductCreateForm from "../-form";
import { getGetProductQueryOptions } from "@/requests/gen/react-query/product";
import { ProductCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_patient-pharmcy-360/product/$productId/edit",
)({
  loader: ({ context: { queryClient }, params: { productId } }) =>
    queryClient.ensureQueryData(
      getGetProductQueryOptions(numericId(productId)),
    ),
  component: ProductEditPage,
});

function ProductEditPage() {
  const { productId } = Route.useParams();
  const productIdInt = numericId(productId);
  const { data: product } = useSuspenseQuery(
    suspenseOptions(getGetProductQueryOptions(productIdInt)),
  );

  return (
    <div>
      <title>
        {`Edit ${product?.catalog_product.product_base.name || "Product"} - Legrande Health Portal`}
      </title>
      <ProductCrumbs />
      {/* Product form */}
      <Card>
        <CardHeader>
          <CardTitle>Edit Product</CardTitle>
          <CardDescription>Enter product details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {product && <ProductCreateForm product={product} />}
        </CardContent>
      </Card>
    </div>
  );
}
